import React from "react";
import "./style.scss";
import { Button } from "primereact/button";

const Banner = ({ image, title, description, onClick = () => {} }) => {
  const bannerStyle = {
    backgroundImage: `url(${image})`,
  };

  return (
    <div className="banner" style={bannerStyle}>
      <p className="banner__heading">{title}</p>
      <p className="banner__description">{description}</p>
      <Button label="Learn More" className="btn-primary" onClick={onClick} />
    </div>
  );
};

export default Banner;
